import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import * as styles from './FormElements.scss';

var LLChip = /*#__PURE__*/function (_Component) {
  _inherits(LLChip, _Component);

  var _super = _createSuper(LLChip);

  function LLChip() {
    _classCallCheck(this, LLChip);

    return _super.apply(this, arguments);
  }

  _createClass(LLChip, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Chip, {
        onRequestDelete: this.props.onRequestDelete,
        style: this.props.style,
        labelStyle: {
          lineHeight: '28px'
        },
        className: styles.chip
      }, this.props.imageUrl && /*#__PURE__*/React.createElement(Avatar, {
        src: this.props.imageUrl
      }), this.props.label);
    }
  }]);

  return LLChip;
}(Component);

_defineProperty(LLChip, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onRequestDelete: PropTypes.any,
  imageUrl: PropTypes.string,
  theme: PropTypes.object.isRequired
});

_defineProperty(LLChip, "defaultProps", {
  label: 'Submit',
  style: {},
  onRequestDelete: null,
  imageUrl: null
});

export { LLChip as default };